<template>
  <el-dialog
    title="目录编辑"
    :visible.sync="state"
    width="30%"
    :before-close="handleClose"
  >
    <!-- 内容 -->
    <tz-form
      width="110px"
      :formConfig="formConfig"
      :formBtns="formBtns"
      :row="user"
      @submit="submitFn"
    ></tz-form>
    <!-- 内容 -->
  </el-dialog>
</template>

<script>
export default {
  props: {
    state: {
      type: Boolean,
      default: false
    },
    user: Object,
    roles: Array
  },

  data() {
    return {
      // 表单配置
      formConfig: [
        {
          label: '标题',
          field: 'title',
          type: 'text',
          rules: [{ required: true, message: '标题必填', trigger: 'blur' }]
        },
        {
          label: '介绍',
          field: 'introduce',
          type: 'text',
          rules: [
            { required: true, message: '介绍必填', trigger: 'blur' }
            // { min: 1, max: 5, message: '简写长度为1到5', trigger: 'blur' }
          ]
        },
        {
          label: '讲解人',
          field: 'explainer',
          type: 'text'
          // rules: [{ required: true, message: '类型必填', trigger: 'blur' }]
        },
        {
          label: '开始时间',
          field: 'startDt',
          type: 'datepicker'
        },
        {
          label: '结束时间',
          field: 'endDt',
          type: 'datepicker'
        },
        // {
        //   label: '状态',
        //   field: 'status',
        //   type: 'radio',
        //   radiolist: [
        //     {
        //       value: 1,
        //       label: '启用'
        //     },
        //     {
        //       value: 2,
        //       label: '禁用'
        //     }
        //   ]
        // },
        {
          label: '备注',
          field: 'remark',
          type: 'text'
        },
        {
          label: '排序',
          field: 'sort',
          type: 'text'
        }
        // {
        //   label: '用户姓名',
        //   field: 'userName',
        //   type: 'text',
        //   rules: [
        //     { required: true, message: '用户姓名必填', trigger: 'blur' },
        //     { min: 2, max: 20, message: '长度为2到20', trigger: 'blur' }
        //   ]
        // },
        // {
        //   label: '角色',
        //   field: 'roleId',
        //   type: 'select',
        //   payload: this.roles,
        //   rules: [{ required: true, message: '角色必选', trigger: 'blur' }]
        // }
      ],

      formBtns: [
        {
          content: '更新',
          width: '185px',
          type: 'primary'
          // },
          // {
          //   content: '重置',
          //   type: ''
        }
      ]
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    submitFn(formData) {
      this.$emit('confirm', formData)
      console.log('更新数据处理', formData)
    }
  }
}
</script>

<style></style>
